module.exports = __webpack_public_path__ + "images/manifest/icon-48x48-67470808290acc080f2d154fd1df70d1.png";